<div fxLayout="column" class="mt-1">
  <mat-checkbox
    name="whatsAppEnabled"
    [checked]="enabled"
    [disabled]="locked"
    (change)="enabledChange.emit($event.checked)"
    class="mdc-mb-1"
  >
    {{ 'ENABLED' | translate }}
  </mat-checkbox>
  <p *ngIf="locked" class="mat-text-secondary">{{ 'WHATSAPP_SENDING_OFF_LOCKED' | translate }}</p>
  <p class="mat-text-secondary">{{ 'WHATSAPP_REMINDER_SENT_WITH_SMS_BACKUP' | translate }}</p>
  <mat-spinner *ngIf="loading" diameter="32"></mat-spinner>
  <p *ngIf="loadError && !loading" class="mat-text-secondary mt-1">
    {{ 'WHATSAPP_TEMPLATE_LOAD_FAILED' | translate }}
    <button mat-stroked-button (click)="load()">{{ 'TRY_AGAIN' | translate }}</button>
  </p>
  <p *ngIf="!template && !loading && !loadError" class="mat-text-secondary mt-1">{{ 'WHATSAPP_TEMPLATE_NONE' | translate }}</p>
  <ng-container *ngIf="template && !loading">
    <div class="mt-1">
      <mat-chip-listbox>
        <mat-chip>{{ 'WHATSAPP_TEMPLATE_STATUS_' + template.status | translate }}</mat-chip>
        <mat-chip *ngIf="template.category">{{ 'WHATSAPP_TEMPLATE_CATEGORY_' + template.category | translate }}</mat-chip>
      </mat-chip-listbox>
    </div>
    <p *ngIf="template.status === 'REJECTED' && template.rejectionReason" class="mat-text-secondary mt-1">{{ template.rejectionReason }}</p>
    <p *ngIf="isAwaitingApproval" class="mat-text-secondary mt-1 wa-approval-note">{{ 'WHATSAPP_TEMPLATE_NOT_APPROVED_NOTE' | translate }}</p>
    <h6 class="mt-1" *ngIf="template.header">{{ 'WHATSAPP_TEMPLATE_SUBJECT' | translate }}</h6>
    <p *ngIf="template.header">{{ template.header }}</p>
    <h6 class="mt-1">{{ 'WHATSAPP_TEMPLATE_MESSAGE' | translate }}</h6>
    <p class="pre-wrap">{{ template.body }}</p>
    <p class="mat-text-secondary">{{ 'WHATSAPP_TEMPLATE_MANAGE_NOTE' | translate }}</p>
  </ng-container>
</div>
